import { render, staticRenderFns } from "./ConfiguracionEstablecimientos.vue?vue&type=template&id=0be23ee9&scoped=true&"
import script from "./ConfiguracionEstablecimientos.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionEstablecimientos.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracionEstablecimientos.vue?vue&type=style&index=0&id=0be23ee9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be23ee9",
  null
  
)

export default component.exports